export function getItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // storage full or unavailable (private browsing)
  }
}

export function removeItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // storage unavailable
  }
}
